/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".blur[_ngcontent-%COMP%]{-webkit-filter:blur(20px);filter:blur(20px);background-color:rgba(23,36,70,.28)}a[_ngcontent-%COMP%]{text-decoration:none;cursor:pointer}a[_ngcontent-%COMP%]:hover{text-decoration:none!important}"];
export { styles as styles };
